import React, { useEffect, useMemo, useState } from 'react';
import { EventFormJsonFields } from '../../../interfaces/Events';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import KenInput from '../../../GlobalComponents/KenInput';
import KenSelect from '../../../GlobalComponents/KenSelect';
import ArrayFields from '../ArrayFields';
import FileUpload from '../FileUpload';
import { useAppFormContext } from '../../../Helpers/Contexts/formContext';
import QuillEditor from '../QuillEditor';
import { useStyles } from '../styles';
import MultiText from '../MultiText';
import CustomDateField from '../CustomDateField';
import QuestionArrayFields from '../QuestionArrayFields';
import { Autocomplete, Box, FormControl, FormControlLabel, FormHelperText, InputAdornment, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import KenTextLabel from '../../../GlobalComponents/KenTextLabel';
import KenTextField from '../../../GlobalComponents/KenTextField';
import KenInputText from '../../../GlobalComponents/KenInputText';
import { getTargetAudiencePicklistValue, picklistValue } from '../../../Utils/apiService';

const FieldsBuilder: React.FunctionComponent<{ fields: EventFormJsonFields }> = (props) => {
  const { fields } = props;
  const classes = useStyles();
  const { control, register, watch } = useFormContext();
  const {
    state: { options, range },
    dispatch,
  } = useAppFormContext();
  // console.log('sdfsd', fields.name);

  const selectedCurrency = useWatch({ name: 'Currency_Type__c' });
  const getCurrencyAdornment = useMemo(() => {
    if (!selectedCurrency || selectedCurrency === 'Rupee') {
      return { adornment: '₹LPA', placeholder: 'Eg: 3-5 ₹LPA' };
    }
    const currencyMap: Record<string, { symbol: string; letter: string }> = {
      Dollar: { symbol: '$', letter: 'D' },
      Euro: { symbol: '€', letter: 'E' },
      Pound: { symbol: '£', letter: 'P' },
      Yen: { symbol: '¥', letter: 'Y' },
      Rupee: { symbol: '₹', letter: 'L' },
    };
    const curr = currencyMap[selectedCurrency] || { symbol: '', letter: '' };
    return {
      adornment: `${curr.symbol}${curr.letter}PA`,
      placeholder: `Eg: 3-5 ${curr.symbol}${curr.letter}PA`,
    };
  }, [selectedCurrency]);

  switch (fields.type) {
    case 'coverField':
      return <FileUpload field={{ ...fields }} />;
    case 'upload':
      return <FileUpload field={{ ...fields }} />;
    case 'arrayField':
      return <ArrayFields {...fields} control={control} />;
    case 'questionArrayField':
      return <QuestionArrayFields {...(fields as any)} />;
    case 'texteditor':
      return <QuillEditor {...fields} />;
    case 'multiText':
      return <MultiText {...fields} />;
    case 'timeRange':
      let fieldRange: any = range[fields.name as any];
      return (
        <>
          {fields.hideLabel && <KenTextLabel label={fields.label} labelClassName={classes.inputLableCustom} />}
          <Box component={'div'} className="d-flex align-items-center">
            <KenTextField
              variant="outlined"
              type="time"
              className={classes.timeRangeField}
              value={fieldRange ? fieldRange['startTime'] : ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                dispatch({ type: 'updateTimeRange', value: { fieldName: fields.name, fileData: { startTime: e.target.value, endTime: fieldRange ? fieldRange['endTime'] : '' } } });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography>Start time</Typography>
                  </InputAdornment>
                ),
              }}
            />
            <KenTextField
              disabled={fieldRange ? !fieldRange['startTime'] : true}
              variant="outlined"
              type="time"
              className={classes.timeRangeField}
              value={fieldRange ? fieldRange['endTime'] : ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                dispatch({ type: 'updateTimeRange', value: { fieldName: fields.name, fileData: { startTime: fieldRange ? fieldRange['startTime'] : '', endTime: e.target.value } } });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography>End time</Typography>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </>
      );
    case 'date':
      return <CustomDateField fields={{ ...fields }} />;
    case 'autoComplete':
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const [apiOptions, setApiOptions] = useState([]);

      console.log(apiOptions, 'apiOptionsapiOptions');

      // eslint-disable-next-line react-hooks/rules-of-hooks
      useEffect(() => {
        if (fields.label === 'Target Audience') {
          getTargetAudiencePicklistValue()
            .then((data) => {
              // console.log(data?.data?.data?.records, 'datadatadata');
              const newOptions = data.data.data.records.map((item: any) => ({
                label: item.Label,
                value: item.Value,
              }));
              setApiOptions(newOptions);
            })
            .catch((error) => console.error('Error fetching picklist values:', error));
        }
      }, [fields.label]);

      return (
        <Controller
          control={control}
          defaultValue={[]}
          render={({ field: { value, onChange } }) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const [processedValue, setProcessedValue] = useState<{ label: string; value: string }[]>([]);

            // eslint-disable-next-line react-hooks/rules-of-hooks
            useEffect(() => {
              if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') {
                const transformed = value[0].split(';').map((lang) => ({
                  label: lang.trim(),
                  value: lang.trim(),
                }));
                setProcessedValue(transformed);
              }
            }, [value]);

            // console.log(fields, "4t34t34y43y");

            return (
              <>
                {fields.hideLabel && <KenTextLabel label={fields.label} labelClassName={classes.inputLableCustom} required={!!fields.validation?.required} />}
                <Autocomplete
                  multiple
                  id="tags-outlined"
                  style={{ width: '100%' }}
                  options={fields.label === 'Target Audience' ? apiOptions : fields.options || []}
                  getOptionLabel={(option) => option?.label || ''}
                  value={processedValue}
                  onChange={(_, newValue) => {
                    setProcessedValue(newValue);
                    onChange(newValue);
                  }}
                  isOptionEqualToValue={(option, value) => option.label === value.label}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={fields.label === 'Target Audience' ? null : fields.label}
                      fullWidth
                      placeholder={processedValue?.length === fields.options?.length ? '' : fields.placeholder}
                      sx={{
                        margin: '6px 0px',
                        '& .MuiOutlinedInput-root': {
                          height: fields.label === 'Target Audience' ? "47px" : 'auto',
                          minHeight: fields.label === 'Target Audience' ? "47px" : '60px',
                          maxHeight: fields.label === 'Target Audience' ? "47px" : '120px',
                          // overflowY: 'auto',
                          borderRadius: '6px',
                          fontSize: '14px',
                          display: 'flex',
                          color: fields.label === 'Target Audience' ? "rgb(148 148 148)" : '#9e9e9e',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                          borderColor: '#E0E0E0 !important', // no change on hover
                          '&:hover fieldset': {
                            borderColor: '#E0E0E0', // no change on hover
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#E0E0E0', // no change on focus/active
                          },
                          '@media (max-width: 1440px)': {
                            minHeight: '45px',
                            maxHeight: '100px',
                            fontSize: '12px',
                          },
                        },
                        '& .MuiInputBase-input': {
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '4px',
                        },
                        '& .MuiInputBase-input::placeholder': {
                          fontSize: '14px',
                          '@media (max-width: 1440px)': {
                            fontSize: '12px',
                          },
                        },
                      }}
                    />
                  )}
                />
              </>
            );
          }}
          {...register(fields.name ?? 'defaultName', fields.validation)}
        />
      );
    case 'radio':
      const customOptions = fields.radioOptions;
      // Add asterisk for required fields if not hidden
      const showAsterisk = fields.required && !fields.hideLabel;
      return (
        <div style={{ ...fields.fieldStyle }}>
          <Controller
            control={control}
            rules={{ ...fields?.validation }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <>
                  {/* {fields.hideLabel && <KenTextLabel label={fields.label} labelClassName={classes.inputLableCustom} />} */}
                  {fields.hideLabel && (
                    <Typography
                      component="label"
                      sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        marginBottom: '4px',
                        display: 'block',
                        color: '#373A45',
                      }}
                    >
                      {fields.label}
                      <span style={{ color: 'red', marginLeft: 2 }}>*</span>
                    </Typography>
                  )}
                  <FormControl component="fieldset" error={!!error}>
                    <RadioGroup onChange={onChange} value={value} {...fields.radioGroupProps}>
                      {customOptions?.map((items, index) => (
                        <FormControlLabel style={{ fontSize: "12px" }} key={index} value={items.value} control={<Radio />} label={items.label} />
                      ))}
                    </RadioGroup>
                    {error && (
                      <FormHelperText
                        style={{
                          color: 'red',
                          fontWeight: 500,
                          padding: 0,
                          margin: 0,
                        }}
                      >
                        {'Field is required'}
                      </FormHelperText>
                    )}
                  </FormControl>
                </>
              );
            }}
            {...register(`${fields.name}`, { ...fields?.validation })}
          />
        </div>
      );
    case 'textarea':
      return (
        <div style={{ ...fields.fieldStyle }}>
          <Controller
            control={control}
            rules={{
              ...fields?.validation,
              minLength: fields?.validation?.minLength || { value: 1, message: 'Minimum 1 characters required' },
              maxLength: fields?.validation?.maxLength || { value: 1000, message: 'Maximum 1000 characters allowed' },
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              // Type guards for min/max
              const minRule = fields?.validation?.minLength;
              const maxRule = fields?.validation?.maxLength;
              const min: number =
                typeof minRule === 'object' && minRule !== null && 'value' in minRule && typeof minRule.value === 'number'
                  ? minRule.value
                  : typeof minRule === 'number'
                    ? minRule
                    : 10;
              const max: number =
                typeof maxRule === 'object' && maxRule !== null && 'value' in maxRule && typeof maxRule.value === 'number'
                  ? maxRule.value
                  : typeof maxRule === 'number'
                    ? maxRule
                    : 1000;
              const showCharCount = (fields as any).showCharCount === true;
              const currentLength = value ? value.length : 0;
              return (
                <>
                  <KenInputText
                    onChange={(e: { target: { value: string | any[] } }) => {
                      if (!fields?.validation?.maxLength || e.target.value.length <= max) {
                        onChange(e);
                      }
                    }}
                    value={value}
                    error={error?.message}
                    border
                    customMargin
                    labelClassName={classes.inputLableCustom1}
                    required={!!fields.validation?.required}
                    label={fields.label}
                    InputProps={{
                      className: classes.inputStyles,
                      inputProps: { minLength: min, maxLength: max },
                    }}
                    {...fields}
                  />
                  {showCharCount && (
                    <div
                      style={{
                        textAlign: 'right',
                        fontSize: 12,
                        color: currentLength >= max ? 'red' : '#888',
                        marginTop: 2,
                        fontWeight: currentLength >= max ? 600 : 400,
                      }}
                    >
                      {currentLength}/{max}
                    </div>
                  )}
                </>
              );
            }}
            {...register(`${fields.name}`, { ...fields?.validation })}
          />
        </div>
      );
    case 'select':
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const [apiOption, setApiOption] = useState([]);
      // console.log(apiOption, 'apiOptionsapiOptions');
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useEffect(() => {
        if (fields.label === 'Currency Type') {
          picklistValue()
            .then((data) => {
              // console.log(data?.data?.data?.records, 'datadatadata');
              const newOptions = data?.data.records.map((item: any) => ({
                label: item.Label,
                value: item.Value,
              }));
              setApiOption(newOptions);
            })
            .catch((error) => console.error('Error fetching picklist values:', error));
        }
      }, [fields.label]);
      return (
        <div style={{ ...fields.fieldStyle }}>
          <Controller
            control={control}
            name={fields.name ?? 'defaultName'}
            rules={{ ...fields?.validation }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              // Use apiOption if label is 'Currency Type', else fallback to customOptions
              const customOptions =
                fields.label === 'Currency Type'
                  ? apiOption
                  : fields.optionsMeta && Object.keys(options).length > 0
                    ? options[`${fields.optionsMeta?.fieldName}`]
                    : fields.options;
              return (
                <KenSelect
                  onChange={onChange}
                  value={value}
                  error={error?.message}
                  border
                  customMargin
                  labelClassName={classes.inputLableCustom}
                  InputProps={{ className: classes.inputStyles }}
                  required={!!fields.validation?.required}
                  {...fields}
                  options={customOptions}
                />
              );
            }}
          />
        </div>
      );
    case 'text':
      return (
        <div style={{ ...fields.fieldStyle }}>
          <Controller
            control={control}
            rules={{
              ...fields?.validation,
              minLength: fields?.validation?.minLength || { value: 1, message: 'Minimum 1 characters required' },
              maxLength: fields?.validation?.maxLength || { value: 100, message: 'Maximum 100 characters allowed' },
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              // Type guards for min/max
              const minRule = fields?.validation?.minLength;
              const maxRule = fields?.validation?.maxLength;
              const min: number =
                typeof minRule === 'object' && minRule !== null && 'value' in minRule && typeof minRule.value === 'number'
                  ? minRule.value
                  : typeof minRule === 'number'
                    ? minRule
                    : 1;
              const max: number =
                typeof maxRule === 'object' && maxRule !== null && 'value' in maxRule && typeof maxRule.value === 'number'
                  ? maxRule.value
                  : typeof maxRule === 'number'
                    ? maxRule
                    : 100;
              return (
                <KenInput
                  border
                  customMargin
                  labelClassName={classes.inputLableCustom}
                  onChange={(e: { target: { value: string | any[] } }) => {
                    if (!fields?.validation?.maxLength || e.target.value.length <= max) {
                      onChange(e);
                    }
                  }}
                  value={value}
                  error={error?.message}
                  required={!!fields.validation?.required}
                  label={fields.label}
                  InputProps={{
                    className: classes.inputStyles,
                    inputProps: {
                      minLength: min,
                      maxLength: max,
                    },
                  }}
                  {...fields}
                />
              );
            }}
            {...register(`${fields.name}`, { ...fields?.validation })}
          />
        </div>
      );
    default:
      return (
        <div style={{ ...fields.fieldStyle }}>
          {fields.name === 'tags' ? (
            <Controller
              control={control}
              render={({ field: { onChange, value }, fieldState: { error } }) => {
                return (
                  <KenInput
                    border
                    customMargin
                    labelClassName={classes.inputLableCustom}
                    onChange={(e: { target: { value: string | any[] } }) => {
                      if (e.target.value.length <= 151) {
                        onChange(e); // Only update the state if it's within the limit
                      }
                    }}
                    value={value}
                    error={error?.message}
                    required={!!fields.validation?.required}
                    label={fields.label}
                    InputProps={{
                      className: classes.inputStyles,
                      inputProps: { maxLength: 151 }, // Restrict user from typing beyond 80
                    }}
                    {...fields}
                  />
                );
              }}
              {...register(`${fields.name}`, { ...fields?.validation })}
            />
          ) : fields.name === 'salary' ? (
            // Dynamic adornment and placeholder for salary
            <Controller
              control={control}
              render={({ field: { onChange, value }, fieldState: { error } }) => {
                const { adornment, placeholder } = getCurrencyAdornment;
                
                // Custom input handling for salary validation
                const handleSalaryChange = (e: { target: { value: string } }) => {
                  const inputValue = e.target.value;
                  
                  // Only allow numbers, hyphens, and decimal points
                  const sanitizedValue = inputValue.replace(/[^0-9.-]/g, '');
                  
                  // Ensure only one hyphen
                  const hyphenCount = (sanitizedValue.match(/-/g) || []).length;
                  if (hyphenCount > 1) {
                    return; // Don't update if more than one hyphen
                  }
                  
                  // Limit length
                  if (sanitizedValue.length <= 20) {
                    onChange({ target: { value: sanitizedValue } });
                  }
                };
                
                return (
                  <KenInput
                    border
                    customMargin
                    labelClassName={classes.inputLableCustom}
                    value={value}
                    error={error?.message}
                    placeholder={placeholder}
                    onChange={handleSalaryChange}
                    required={!!fields.validation?.required}
                    label={fields.label}
                    InputProps={{
                      ...fields.InputProps,
                      endAdornment: adornment,
                      className: classes.inputStyles,
                      inputProps: {
                        ...(fields.InputProps || {}),
                        maxLength: 20,
                      } as React.InputHTMLAttributes<HTMLInputElement>,
                    }}
                  />
                );
              }}
              {...register(`${fields.name}`, { ...fields?.validation })}
            />
          ) : (
            <Controller
              control={control}
              render={({ field: { onChange, value }, fieldState: { error } }) => {
                return (
                  <KenInput
                    border
                    customMargin
                    labelClassName={classes.inputLableCustom}
                    onChange={(e: { target: { value: string | any[] } }) => {
                      if (e.target.value.length <= 81) {
                        onChange(e);
                      }
                    }}
                    value={value}
                    error={error?.message}
                    required={!!fields.validation?.required}
                    label={fields.label}
                    InputProps={{
                      className: classes.inputStyles,
                      inputProps: { maxLength: 81 },
                    }}
                    {...fields}
                  />
                );
              }}
              {...register(`${fields.name}`, { ...fields?.validation })}
            />
          )}
        </div>
      );
  }
};

export default FieldsBuilder;
